import React from "react"
import { Helmet } from "react-helmet"
import hopkins_symbol from "./favicons/hopkins_symbol.png"
import hopkins_32 from "./favicons/hopkins_32.png"
import hopkins_16 from "./favicons/hopkins_16.png"
import SafariPinned from "./favicons/safari-pinned-tab.svg"

var DomParser = require("dom-parser")
var parser = new DomParser()

export default ({ title, metaTags }) => {
  const parsed = metaTags && parser.parseFromString(metaTags)
  const tags = metaTags
    ? Array.from(parsed.getElementsByTagName("meta")).map(child => (
        <meta
          content={child.getAttribute("content")}
          name={child.getAttribute("name")}
        />
      ))
    : []

  return (
    <Helmet>
      {tags}
      <meta charSet="utf-8" />
      <title>{title || "Hopkins"}</title>
      <link rel="apple-touch-icon" sizes="180x180" href={hopkins_symbol} />
      <link rel="icon" type="image/png" sizes="32x32" href={hopkins_32} />
      <link rel="icon" type="image/png" sizes="16x16" href={hopkins_16} />
      <link rel="mask-icon" href={SafariPinned} color="#5bbad5" />
      <link
        rel="preload"
        href="/fonts/GT-America-Standard-Regular.otf"
        as="font"
        type="font/otf"
        crossorigin="anonymous"
      />
      <link
        rel="preload"
        href="/fonts/RecifeText-SemiBold.otf"
        as="font"
        type="font/otf"
        crossorigin="anonymous"
      />
      <link rel="stylesheet" href="/fonts/fonts.css" type="text/css" />

      <meta name="msapplication-TileColor" content="#FFFFFF" />
      <meta name="theme-color" content="#ffffff" />
      <link rel="alternate" hreflang="de" href="https://www.hopkins.law" />
      <link
        rel="alternate"
        hreflang="x-default"
        href="https://www.hopkins.law"
      />
      <script
        type="text/javascript"
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        async
        defer
      ></script>
    </Helmet>
  )
}
